import '../styles/landing.css'

export default function About() {
  return (
    <section id="about" className="section section-alt">
      <div className="container">
        <div className="text-center mb-2xl">
          <h1>¿Qué es Vortex EXANI-II?</h1>
          <p style={{ maxWidth: '700px', margin: '0 auto' }}>
            La plataforma líder de preparación académica para aspirantes a nivel Licenciatura en universidades públicas y autónomas de México.
          </p>
        </div>

        <div className="grid grid-3">
          {[
            { icon: '/icons/captain.png', title: 'Prepárate con rigor', text: 'Estrategia probada para dominar los 168 reactivos del EXANI-II Ceneval con disciplina y consistencia.' },
            { icon: '/icons/books.png',   title: 'Estudio Personalizado', text: 'Enfócate en tus módulos disciplinares según tu carrera objetivo (Salud, Premedicina, Ingenierías, etc.).' },
            { icon: '/icons/read.png',    title: 'Simulación Real',   text: 'Entrena con cronómetro oficial de 4.5 horas y reactivos calibrados con 3 opciones de respuesta Ceneval.' },
          ].map(({ icon, title, text }) => (
            <div key={title} className="icon-card">
              <div className="icon-circle">
                <img src={icon} alt={title} style={{ width: '55px' }} />
              </div>
              <h3 style={{ marginBottom: 'var(--spacing-sm)' }}>{title}</h3>
              <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6 }}>{text}</p>
            </div>
          ))}
        </div>

        <div className="about-banner">
          <h3>
            Diseñada para aspirantes de alto rendimiento a universidades públicas y autónomas de México.
          </h3>
          <p>
            Vortex EXANI-II integra todas las herramientas necesarias para tu éxito en la admisión:
            simuladores completos de 168 reactivos, diagnóstico por áreas predictivas (Comprensión Lectora,
            Redacción Indirecta y Pensamiento Matemático), módulos de conocimientos específicos y diagnóstico de Inglés B1.
            Con nuestra tecnología de Inteligencia Artificial podrás generar bancos de reactivos personalizados, consultar dudas
            conceptuales en segundos y transformar tus guías en audios de estudio continuo.
          </p>
        </div>
      </div>
    </section>
  )
}